var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2024-09-12
 * @brief SEI - Report 공용 장바구니 컴포넌트
 *
 ********************************************************************/
import { alertState } from "@recoil/assessmentState";
import { loadingBoxState } from "@recoil/menuState";
import { reLoadPage, reLoadState, userInfoLoginState } from "@recoil/userState";
import { useTrans } from "@utils/langs/useTrans";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// utils
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
export default function ReportBasketsPop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadState = useSetRecoilState(reLoadState);
    const setReLoadPages = useSetRecoilState(reLoadPage);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const { basketsItem, setBasketsItem, setWork } = props;
    // 체크 박스 작업 하기
    //   console.log("baskeCheck", baskeCheck);
    useEffect(() => {
        if (CUTIL.isnull(basketsItem))
            return;
    }, [basketsItem]);
    // 전체 선택
    const BaskteAllCheck = (check) => {
        if (check) {
            setBasketsItem({
                checkAll: true,
                title: basketsItem.title.map((list) => (Object.assign(Object.assign({}, list), { groupChecked: true }))),
                content: basketsItem.content.map((list) => (Object.assign(Object.assign({}, list), { checked: true }))),
            });
        }
        else {
            setBasketsItem({
                checkAll: false,
                title: basketsItem.title.map((list) => (Object.assign(Object.assign({}, list), { groupChecked: false }))),
                content: basketsItem.content.map((list) => (Object.assign(Object.assign({}, list), { checked: false }))),
            });
        }
    };
    // 그룹 선택
    function BaskteSubAllCheck(check, code) {
        if (check) {
            setBasketsItem({
                checkAll: basketsItem.title.filter((item) => item.groupChecked).length + 1 == basketsItem.title.length ? true : false,
                title: basketsItem.title.map((list) => list.code == code
                    ? Object.assign(Object.assign({}, list), { groupChecked: check }) : list),
                content: basketsItem.content.map((list) => list.code == code
                    ? Object.assign(Object.assign({}, list), { checked: check }) : list),
            });
        }
        else {
            setBasketsItem({
                checkAll: check,
                title: basketsItem.title.map((list) => list.code == code
                    ? Object.assign(Object.assign({}, list), { groupChecked: check }) : list),
                content: basketsItem.content.map((list) => list.code == code
                    ? Object.assign(Object.assign({}, list), { checked: check }) : list),
            });
        }
    }
    // checkbox
    function CheckedList(checked, code, id) {
        if (checked) {
            setBasketsItem({
                checkAll: basketsItem.content.filter((item) => item.checked).length + 1 == basketsItem.content.length ? true : false,
                title: basketsItem.title.map((list) => list.code == code
                    ? Object.assign(Object.assign({}, list), { groupChecked: basketsItem.content.filter((item) => item.code == code && item.checked).length + 1 ==
                            basketsItem.content.filter((item) => item.code == code).length
                            ? checked
                            : false }) : list),
                content: basketsItem.content.map((list) => list.basketId == id
                    ? Object.assign(Object.assign({}, list), { checked: checked }) : list),
            });
        }
        else {
            setBasketsItem({
                checkAll: false,
                title: basketsItem.title.map((list) => list.code == code
                    ? Object.assign(Object.assign({}, list), { groupChecked: checked }) : list),
                content: basketsItem.content.map((list, idx) => list.basketId == id
                    ? Object.assign(Object.assign({}, list), { checked: checked }) : list),
            });
        }
    }
    function TotalReportAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment/totalreport`,
                appQuery: {
                    assessmentId: basketsItem.content
                        .filter((typef) => typef.reportType == "assessment")
                        .map((item) => item.reportTypeId),
                    energyReportId: basketsItem.content
                        .filter((typef) => typef.reportType !== "assessment")
                        .map((item) => item.reportTypeId),
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.종합레포트가생성되었습니다"), callBack: () => {
                            setReloadState(true);
                            CUTIL.jsclose_Popup("pop-report");
                            setWork("total");
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                }
            }
        });
    }
    //삭제
    function ReportDel(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/assessment/basket/${item.basketId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    // title의 cnt 제거
                    const filteredTitles = basketsItem.title.map((list) => list.code == item.code ? Object.assign(Object.assign({}, list), { cnt: list.cnt.filter((val) => val !== item.basketId) }) : list);
                    const filteredTitle = filteredTitles.filter((list) => list.cnt.length > 0).length;
                    if (filteredTitle > 0) {
                        setBasketsItem(Object.assign(Object.assign({}, basketsItem), { title: filteredTitles.filter((list) => list.cnt.length > 0), content: basketsItem.content.filter((list) => list.basketId !== item.basketId) }));
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-nonreport", type: CONST.TYPE_ERROR, divTag: t("라벨.현재장바구니의목록이없습니다"), callBack: () => {
                                setReloadState(true);
                                CUTIL.jsclose_Popup("pop-report");
                                setBasketsItem(null);
                                CUTIL.jsclose_InPopup(CONST.POP_ALERT);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    return;
                }
                else {
                    // need error handle
                }
            }
        });
    }
    function ReportArrDel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let success = [];
            let fail = [];
            let data = [];
            setRecoilIsLoadingBox(true);
            for (let i = 0; i < basketsItem.content.filter((item) => item.checked).length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/assessment/basket/${basketsItem.content.filter((item) => item.checked)[i].basketId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-nonreport", type: CONST.TYPE_ERROR, pTag: {
                            p1: success.length > 0 ? `${success.length.toString()}${t("라벨.건삭제되었습니다")}` : "",
                            p2: fail.length > 0 ? `${fail.length.toString()}${t("라벨.건이오류로인하여삭제가안되었습니다")}` : "",
                        }, callBack: () => {
                            setReLoadPages(true);
                            CUTIL.jsclose_InPopup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                    return;
                }
                else {
                    setRecoilIsLoadingBox(false);
                    // need error handle
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [basketsItem && (_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "check-area" }, { children: [_jsxs("div", Object.assign({ className: "check-top" }, { children: [_jsx("input", { type: "checkbox", id: "c-all", onChange: (e) => BaskteAllCheck(e.target.checked), checked: basketsItem.checkAll }), _jsx("label", Object.assign({ htmlFor: "c-all" }, { children: _jsx("span", { children: t("라벨.전체선택") }) })), _jsx("button", Object.assign({ className: "btn btn-txt", disabled: basketsItem.content.filter((item) => item.checked).length > 0 ? false : true, onClick: (e) => ReportArrDel(e) }, { children: _jsx("span", { children: t("라벨.선택삭제") }) }))] })), _jsx("div", Object.assign({ className: "check-list" }, { children: basketsItem.title.map((report, idx) => (_jsxs("section", { children: [_jsx("input", { type: "checkbox", id: "c-" + idx, checked: report.groupChecked, onChange: (e) => BaskteSubAllCheck(e.target.checked, report.code), style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "c-" + idx }, { children: _jsx("span", Object.assign({ className: `${report.code > 0 ? "premium" : ""}` }, { children: report.name })) })), _jsx("ul", { children: basketsItem.content
                                            .filter((item) => report.code == item.code)
                                            .map((list, index) => (_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: "c-" + idx + index, checked: list.checked, onChange: (e) => CheckedList(e.target.checked, list.code, list.basketId), style: { display: "none" } }), _jsx("label", Object.assign({ htmlFor: "c-" + idx + index }, { children: list.reportType == "assessment" ? (_jsx("div", Object.assign({ className: "tooltip-link", "data-tooltip": `${list.checkSubTypeName}/${list.spgName}/${list.itemName}/${list.updatedTime ? dayjs(list.updatedTime).format("YYYYMMDD") : ""}` }, { children: _jsx("p", { children: `${list.checkSubTypeName}/${list.spgName}/${list.itemName}/${list.updatedTime ? dayjs(list.updatedTime).format("YYYYMMDD") : ""}` }) }))) : (_jsx("div", Object.assign({ className: "tooltip-link", "data-tooltip": `${list.reportName}/${list.updatedTime ? dayjs(list.updatedTime).format("YYYYMMDD") : ""}` }, { children: _jsxs("p", { children: [report.code > 0 && _jsx("span", Object.assign({ className: "badge" }, { children: "Premium" })), `${list.reportName}/${list.updatedTime ? dayjs(list.updatedTime).format("YYYYMMDD") : ""}`] }) }))) })), _jsx("button", Object.assign({ className: "btn btn-delete-gr", onClick: (e) => ReportDel(list) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD\uC0AD\uC81C" })) }))] }, "baskets_" + index.toString()))) })] }, "reportName_" + idx.toString()))) }))] })) }))), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsxs("div", Object.assign({ className: "flex-column w100p" }, { children: [_jsxs("p", Object.assign({ className: "result__num" }, { children: [_jsxs("span", { children: [basketsItem && basketsItem.content.filter((item) => item.checked).length, "/", basketsItem && basketsItem.content.length] }), t("라벨.선택됨")] })), _jsx("button", Object.assign({ type: "button", onClick: (e) => TotalReportAdd(e) }, { children: _jsx("span", { children: t("라벨.종합레포트생성") }) }))] })) }))] }));
}
